var path = '/components/directives/customfield/customfield.tpl.html';
var html = "<ng-include ng-if=\"field.definition.type\" src=\"'/components/directives/customfield/'+field.definition.type+'.tpl.html'\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/customfield.tpl.html
// module id = 1983
// module chunks = 1